import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import SchedulerComponent from './Scheduler';
import React from 'react';
import Box from '@mui/material/Box';
const EventStaff = () => {
  const [value, setValue] = React.useState(undefined);

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <>
      <Box
        sx={{
          '& .scheduler-view': {
            background: '#fefefe !important',
          },
          '& .resource-view': {
            background: '#fefefe !important',
          },
          '& table.scheduler-bg-table th, table.scheduler-bg-table td': {
            background: '#fefefe !important',
            color: '#282828 !important',
          },
          width: '100%',
        }}
      >
        <SchedulerComponent />
      </Box>
    </>
  );
};

export default EventStaff;
